export default {
  tableMemberList: state => {
    return state.memberList
  },
  tableMemberMigrationList: state => {
    return state.memberMigrationList
  },
  tableMemberStatusList: state => {
    return state.memberStatusList
  },
  getMemberData: state => {
    return state.memberData.data
  },
  tableMemberTransactionList: state => {
    return state.memberWalletTransactionList
  },
  tableDataMemberSalesHistory: state => {
    return state.memberSalesHistoryList
  },
  getOnBehalfToken: state => {
    return state.memberOnBehalfToken.data
  },
  getMemberNextPlacement: state => {
    return state.memberNextPlacement.data.next_placement || false
  },
  tableDownlinePerformance: state => {
    return state.downlinePerformanceList
  },
  tableSponsorDownlineListing: state => {
    return state.memberSponsorDownlineListing.list
  },
}
